var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordKengsob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6667 7H3.33333C2.04467 7 1 7.99492 1 9.22222V14.7778C1 16.0051 2.04467 17 3.33333 17H12.6667C13.9553 17 15 16.0051 15 14.7778V9.22222C15 7.99492 13.9553 7 12.6667 7Z",
    stroke: "#EE5294",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 429",
    d: "M5.5 10.5H10.5",
    stroke: "#EE5294",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 1C9.06087 1 10.0783 1.37928 10.8284 2.05442C11.5786 2.72955 12 3.64522 12 4.6V7H4V4.6C4 3.64522 4.42143 2.72955 5.17157 2.05442C5.92172 1.37928 6.93913 1 8 1Z",
    stroke: "#EE5294",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordKengsob);
export default __webpack_public_path__ + "static/media/icon_password_kengsob.b6fd14a3c5799dbb68ca562757f334c6.svg";
export { ForwardRef as ReactComponent };